export default {
    "data":{
        "pc":{
            "imgList":[
                "https://s20.lgstatic.com/growth/activity/20210630/1625036698997.png",
                "https://s21.lgstatic.com/growth/activity/20210701/1625127754681.png"
            ],
            "swiperList":[
                "https://s20.lgstatic.com/growth/activity/20210630/1625034170013.png",
                "https://s20.lgstatic.com/growth/activity/20210630/1625034155365.png",
                "https://s20.lgstatic.com/growth/activity/20210701/1625104844435.png"
            ],
            "pcSwiperList1":[
                "https://s21.lgstatic.com/growth/activity/20210701/1625109800682.png",
                "https://s21.lgstatic.com/growth/activity/20210701/1625109809082.png",
                "https://s21.lgstatic.com/growth/activity/20210701/1625109817461.png"
            ],
            "pcSwiperList2":[
                "https://s20.lgstatic.com/growth/activity/20210701/1625122566632.png",
                "https://s20.lgstatic.com/growth/activity/20210701/1625122574226.png",
                "https://s21.lgstatic.com/growth/activity/20210701/1625122583453.png"
            ],
            "titleBgdList":[
                "https://s21.lgstatic.com/growth/activity/20210630/1625036036008.png",
                "https://s20.lgstatic.com/growth/activity/20210630/1625037537882.png",
                "https://s21.lgstatic.com/growth/activity/20210630/1625041451372.png",
                "https://s21.lgstatic.com/growth/activity/20210701/1625109554464.png",
                "https://s20.lgstatic.com/growth/activity/20210701/1625110568428.png",
                "https://s21.lgstatic.com/growth/activity/20210701/1625121102753.png",
                "https://s21.lgstatic.com/growth/activity/20210701/1625122315592.png",
                "https://s20.lgstatic.com/growth/activity/20210701/1625122324550.png",
                "https://s20.lgstatic.com/growth/activity/20210701/1625122331978.png",
                "https://s20.lgstatic.com/growth/activity/20210701/1625122339479.png"
            ],
            "btnList":[
                "https://s21.lgstatic.com/growth/activity/20210630/1625036847978.png",
                "https://s21.lgstatic.com/growth/activity/20210701/1625109220204.png",
                "https://s21.lgstatic.com/growth/activity/20210701/1625120611961.png",
            ],
            "phaseList": [
                {
                    "phaseTitle": "第一阶段",
                    "phaseDesi": "JavaSE",
                    "class": "课时：90小时",
                    "phaseTargetList": [
                        "熟悉 JVM、JRE、JDK 等Java核心概念和IDEA开发环境",
                        "熟悉 Java 基本语法、基本类型、运算符和表达式",
                        "理解面向对象思想和概念，学会面向对象分析方法",
                        "掌握 Java 核心类库的应用，例如字符串、日期、集合的处理",
                        "掌握异常处理、IO流对文件读写、多线程应用、网络编程等核心类库",
                        "熟悉 Java8-11 的一些新特性， 了解 Java 各个版本的特性和区别"
                    ],
                    "skillsList": [
                        "Java核心概念",
                        "Java核心语法",
                        "Java数组",
                        "面向对象编程",
                        "高级类特性",
                        "Java API",
                        "异常处理",
                        "集合与泛型",
                        "Java IO流",
                        "Java NIO技术",
                        "Java 多线程",
                        "Java Reflection(Java反射)",
                        "网络编程",
                        "Java8 新特性",
                        "Java9",
                        "Java10",
                        "Java11新特性",
                        "JavaSE项目"
                    ],
                    "moduleList": [
                        {
                            "title": "Java编程语言概述",
                            "skillList": [
                                "计算机语言介绍",
                                "Java语言的前世今生",
                                "Java技术体系平台",
                                "Java核心机制与JVM运行原理",
                                "搭建 Java开发环境",
                                "JDK 的安装与配置",
                                "开发第一个Java 应用程序",
                                "Java 程序的执行原理",
                                "Java Code Style",
                                "变量的声明与使用",
                                "变量内存空间分配与原理",
                                "进制与位运算",
                                "变量的数据类型",
                                "数据类型之间的转换",
                                "变量的运算与底层运算原理"
                            ]
                        },
                        {
                            "title": "Java基础语法",
                            "skillList": [
                                "流程控制语句的介绍",
                                "Java 编译器执行流程",
                                "if 分支结构",
                                "switch 选择结构与相关规则",
                                "循环结构",
                                "for 循环",
                                "while 循环",
                                "do-while 循环语句",
                                "各语句性能对比与应用场景",
                                "特殊流程控制语句",
                                "方法的声明与使用",
                                "方法调用的过程分析",
                                "跨类调用方法",
                                "参数的值传递",
                                "方法的重载 Overload"
                            ]
                        },
                        {
                            "title": "Java数组",
                            "skillList": [
                                "static 修饰符",
                                "类的成员之代码块",
                                "静态代码块与非静态代码块",
                                "单例 (Singleton) 设计模式",
                                "final 修饰符",
                                "包 (package) 的管理与作用",
                                "DOS 命令行下编译器操作",
                                "使用 jar 命令打包应用程序",
                                "数组的创建与使用",
                                "一维数组与多维数组",
                                "数组的默认初始化与内存分析",
                                "数组的常见算法分析",
                                "操作数组的工具类 Arrays",
                                "命令行参数",
                                "可变参数"
                            ]
                        },
                        {
                            "title": "面向对象编程",
                            "skillList": [
                                "面向对象和面向过程的理解",
                                "类和对象的理解",
                                "类和对象的创建、使用",
                                "属性",
                                "方法",
                                "包",
                                "this",
                                "构造器",
                                "封装",
                                "JavaBean",
                                "继承",
                                "super关键字",
                                "重写",
                                "多态",
                                "Object类"
                            ]
                        },
                        {
                            "title": "高级类特性",
                            "skillList": [
                                "抽象类 (abstract) 实际应用举例",
                                "接口 (interface) 的应用与常见问题",
                                "Java8/Java9/Java10对接口的改进",
                                "Template Method 设计模式",
                                "Factory Method 设计模式",
                                "代理模式 (Proxy)",
                                "类的成员之内部类",
                                "匿名内部类",
                                "Java8 中匿名内部类的新特性",
                                "Enum枚举",
                                "枚举的属性与方法",
                                "接口实现枚举类",
                                "Annotation 注解",
                                "JDK 内置注解",
                                "自定义注解",
                                "元注解"
                            ]
                        },
                        {
                            "title": "Java API",
                            "skillList": [
                                "Wrapper 包装类",
                                "装箱与拆箱",
                                "包装类的缓存分析",
                                "字符串处理类",
                                "String 类的使用与内存原理",
                                "String 类的算法分析",
                                "StringBuffer 与 StringBuilder",
                                "字符串处理类性能分析",
                                "其他常用类",
                                "Java.lang.System类",
                                "Java.util.Date类",
                                "Java.text.SimpleDateFormat类",
                                "Java.util.Calendar类",
                                "Java.lang.Math类",
                                "Java.math.BigInteger类与Java.math.BigDecimal"
                            ]
                        },
                        {
                            "title": "异常处理",
                            "skillList": [
                                "异常的原理",
                                "异常的堆栈抛出机制",
                                "异常的结构体系",
                                "受检与非受检异常",
                                "异常的处理",
                                "try-catch 示例",
                                "使用finally回收资源",
                                "throw 制造异常",
                                "异常的处理方式之throws",
                                "Java 7增强的throw 语句",
                                "方法重写与 throws",
                                "自定义异常",
                                "实战中自定义异常的应用解析",
                                "异常信息的访问",
                                "Java 程序的常见问题及解决方法"
                            ]
                        },
                        {
                            "title": "集合与泛型",
                            "skillList": [
                                "集合框架概述",
                                "Collection 系列集合",
                                "List 系列集合与Set系列集合",
                                "java.util.ArrayList源码与数据结构分析",
                                "java.util.LinkedList 源码分析",
                                "java.util.HashSet 内部原理",
                                "java.util.TreeSet 数据结构分析",
                                "java7 中Map 系列集合与数据结构分析",
                                "java8 中 Map 系列集合新特性对比",
                                "java.util.concurrent.ConcurrentHashMap",
                                "Iterator 与 ListIterator",
                                "Collections 工具类",
                                "集合中使用泛型",
                                "自定义泛型",
                                "通配符"
                            ]
                        },
                        {
                            "title": "Java IO流",
                            "skillList": [
                                "IO流结构体系",
                                "IO流原理分析",
                                "IO流的分类",
                                "IO流与文件操作",
                                "IO流的包装与链接",
                                "缓冲流",
                                "文件的复制与性能对比",
                                "对象流",
                                "对象的序列化与反序列化",
                                "控制台IO",
                                "标准输入流与标准输出流",
                                "打印流",
                                "转换流",
                                "字符编码与解码",
                                "RandomAccessFile 类",
                                "NIO技术"
                            ]
                        },
                        {
                            "title": "Java 多线程",
                            "skillList": [
                                "线程的原理",
                                "线程的创建与启动",
                                "创建线程的几种方式对比",
                                "继承 Thread 类与实现 Runnable 接口",
                                "创建线程方式对比",
                                "线程的控制",
                                "线程的调度",
                                "线程的优先级",
                                "线程的生命周期",
                                "多线程的安全问题与解决办法",
                                "线程的同步",
                                "互斥锁",
                                "线程的死锁问题",
                                "线程通信",
                                "生产者与消费者案例"
                            ]
                        },
                        {
                            "title": "Java Reflection(Java反射)",
                            "skillList": [
                                "Java 反射机制的研究与应用",
                                "反射的原理分析",
                                "JVM与类",
                                "类的加载、连接、初始化",
                                "类初始化的时机",
                                "类加载器 ClassLoader简介",
                                "类加载机制",
                                "创建并使用自定义的类加载器",
                                "开启反射的源头 Class",
                                "获取 Class 实例的四种方式",
                                "从 Class 中获取信息",
                                "Proxy 和 InvocationHandler 创建动态代理",
                                "动态代理和AOP(Aspect Orient Programming)",
                                "泛型和Class类",
                                "使用反射来获取泛型信息"
                            ]
                        },
                        {
                            "title": "网络编程",
                            "skillList": [
                                "网络编程基础知识",
                                "网络编程的主要问题",
                                "如何实现网络中主机的相互通讯",
                                "网络通讯要素",
                                "网络通信协议",
                                "OSI参考模型",
                                "TCP/IP参考模型(或TCP/IP协议)",
                                "数据的封装与拆封",
                                "Java.net.InetAddress 类",
                                "TCP 协议与UDP协议",
                                "基于TCP协议的网络编程",
                                "Socket 的TCP编程",
                                "基于UDP协议的网络编程",
                                "URL编程",
                                "针对HTTP协议的URLConnection"
                            ]
                        },
                        {
                            "title": "Java8 新特性",
                            "skillList": [
                                "Lambda 表达式",
                                "类型推断",
                                "Java8核心函数式接口",
                                "Lambda表达式的参数传递",
                                "方法引用与构造器引用",
                                "强大的 Stream API",
                                "Stream 操作的核心步骤",
                                "惰性求值与内部迭代",
                                "筛选与切片",
                                "映射与排序",
                                "查找与匹配",
                                "归约与收集",
                                "并行流与串行流",
                                "Optional 容器类"
                            ]
                        },
                        {
                            "title": "Java9/Java10/Java11新特性",
                            "skillList": [
                                "模块化系统",
                                "jShell命令",
                                "接口的私有方法",
                                "语法改进：try和钻石操作符",
                                "String存储结构变更",
                                "增强的Stream API",
                                "全新的HTTP客户端API",
                                "局部变量的类型推断",
                                "集合新增创建不可变集合的方法",
                                "字符串新增一系列处理方法",
                                "Optional加强",
                                "更简化的编译运行程序",
                                "废弃Nashorn引擎",
                                "ZGC"
                            ]
                        },
                        {
                            "title": "JavaSE项目",
                            "skillList": []
                        }
                    ]
                },
                {
                    "phaseTitle": "第二阶段",
                    "phaseDesi": "数据库技术",
                    "class": "课时：21小时",
                    "phaseTargetList": [
                        "熟悉 MySQL 数据库的安装和使用",
                        "精通 SQL 语句的编写和优化",
                        "掌握数据库设计原则和方法",
                        "熟悉 JDBC 开发 API，对数据库的访问",
                        "熟悉多种数据库连接池原理和使用，提升数据库操作性能",
                        "熟悉 XML 文件的基本语法和规范",
                        "掌握 Java 对 XML 文件的解析技"
                    ],
                    "skillsList": [
                        "MySQL环境",
                        "表设计",
                        "DDL、DQL、DML、DCL",
                        "MySQL约束",
                        "MySQL事务",
                        "多表操作",
                        "MySQL索引",
                        "触发器",
                        "存储过程",
                        "JDBC API",
                        "批处理",
                        "元数据",
                        "C3P0、DBCP、Druid",
                        "commons-dbutil",
                        "DAO模式",
                        "XML语法",
                        "XML解析",
                        "DOM4j",
                        "XPath",
                        "数据库项目"
                    ],
                    "moduleList": [
                        {
                            "title": "MySQL",
                            "skillList": [
                                "Mysql的安装和使用",
                                "图解Mysql程序结构",
                                "Mysql服务器的配置",
                                "Mysql 客户端使用",
                                "用户权限管理",
                                "Mysql数据库的使用"
                            ]
                        },
                        {
                            "title": "SQL语言",
                            "skillList": [
                                "SQL语句的三种类型",
                                "DML、DDL、DCL",
                                "数据处理",
                                "子查询",
                                "创建和管理表",
                                "约束与分页"
                            ]
                        },
                        {
                            "title": "JDBC操作",
                            "skillList": [
                                "JDBC概述",
                                "获取数据库连接",
                                "数据库连接池C3P0 、DBCP、Druid",
                                "使用JDBC 完成数据库DML操作",
                                "大数据的操作",
                                "批量处理与元数据"
                            ]
                        },
                        {
                            "title": "DBUtils",
                            "skillList": [
                                "使用QueryRunner",
                                "可插拔式结果集处理",
                                "批量处理",
                                "大数据结果集处理",
                                "自定义结果集处理",
                                "利用DBUtils编写通用 DAO"
                            ]
                        }
                    ]
                },
                {
                    "phaseTitle": "第三阶段",
                    "phaseDesi": "前端技术",
                    "class": "课时：21小时",
                    "phaseTargetList": [
                        "能熟练设计体验度高的 HTML 页面",
                        "熟悉 CSS3 语法和属性，对 HTML 内容进行渲染",
                        "熟悉 JavaScript 基本语法，对HTML元素进行控制",
                        "掌握ES6语法新特性及应用",
                        "熟悉 jQuery框架各种处理函数，实现各种页面特效",
                        "掌握 BootStrap框架语法和各种应用",
                        "掌握 Vue.js 框架语法和"
                    ],
                    "skillsList": [
                        "VSCode",
                        "HTML5",
                        "CSS3",
                        "JavaScript",
                        "Ajax",
                        "JSON",
                        "JQuery",
                        "ES6",
                        "BootStrap",
                        "Vue"
                    ],
                    "moduleList": [
                        {
                            "title": "XML",
                            "skillList": [
                                "XML用途",
                                "XML文档结构",
                                "XML基本语法",
                                "DOM&SAX解析体系",
                                "DOM4j节点查询",
                                "DOM4j文档操作",
                                "xPath语法",
                                "xPath快速查询"
                            ]
                        },
                        {
                            "title": "HTML",
                            "skillList": [
                                "B/S架构",
                                "HTML基本使用",
                                "HTML DOM"
                            ]
                        },
                        {
                            "title": "CSS",
                            "skillList": [
                                "CSS选择器",
                                "常用样式",
                                "盒子模型与布局",
                                "HTML5新特性",
                                "CSS3新特性"
                            ]
                        },
                        {
                            "title": "JavaScript",
                            "skillList": [
                                "JavaScript基本语法",
                                "JavaScript流程控制",
                                "数组、函数、对象的使用",
                                "JavaScript事件绑定/触发",
                                "JavaScript事件冒泡",
                                "JavaScript嵌入方式",
                                "JavaScript DOM操作",
                                "DOM API"
                            ]
                        },
                        {
                            "title": "Jquery",
                            "skillList": [
                                "jQuery快速入门",
                                "jQuery语法详解",
                                "jQuery核心函数",
                                "jQuery对象/JavaScript对象",
                                "jQuery选择器",
                                "jQuery 文档处理",
                                "jQuery事件",
                                "jQuery动画效果"
                            ]
                        },
                        {
                            "title": "ES6",
                            "skillList": [
                                "前端开发工程师、ES6简介",
                                "ES6基础语法：let、const",
                                "ES6基础语法：解构赋值、模板字符串",
                                "ES6基础语法：声明对象、方法简写",
                                "ES6基础语法：对象拓展运算符、函数默认参数、不定参数、箭头函数",
                                "ES6基础语法：Promise",
                                "ES6模块化+总结"
                            ]
                        }
                    ]
                },
                {
                    "phaseTitle": "第四阶段",
                    "phaseDesi": "JavaWEB核心",
                    "class": "课时：23小时",
                    "phaseTargetList": [
                        "掌握 Tomcat 环境的安装和使用",
                        "熟悉 Servlet 开发规范和相关概念",
                        "掌握 session 和 cookie 状态管理技术",
                        "掌握 Filter 和 Listener 组件的使用",
                        "熟悉 JSP 基本语法和标记",
                        "能熟练使用 JSTL 和 EL 显示数据",
                        "理解 MVC 模式思想和优点，能自定义MVC"
                    ],
                    "skillsList": [
                        "Tomcat",
                        "Servlet",
                        "JSP",
                        "JavaBean",
                        "Cookie",
                        "Session",
                        "Filter",
                        "Listener",
                        "MVC模式",
                        "三层架构",
                        "Linux操作",
                        "Shell编程"
                    ],
                    "moduleList": [
                        {
                            "title": "Tomcat",
                            "skillList": [
                                "HTTP协议",
                                "HttpWatch",
                                "Tomcat服务器搭建",
                                "Tomcat目录结构解析",
                                "Tomcat端口配置",
                                "Tomcat启动&停止",
                                "Tomcat&Idea整合"
                            ]
                        },
                        {
                            "title": "Servlet",
                            "skillList": [
                                "Servlet体系",
                                "Servlet生命周期",
                                "ServletConfig&ServletContext",
                                "请求&响应",
                                "重定向&转发",
                                "中文乱码解决方案",
                                "项目路径问题",
                                "Request",
                                "Response"
                            ]
                        },
                        {
                            "title": "Jsp",
                            "skillList": [
                                "JSP语法",
                                "JSP原理",
                                "JSP脚本片段&表达式",
                                "JSP声明&指令",
                                "JSP九大隐含对象",
                                "域对象使用",
                                "EL表达式",
                                "JSTL"
                            ]
                        },
                        {
                            "title": "Cookie&Session",
                            "skillList": [
                                "Cookie机制",
                                "Cookie创建&使用",
                                "Session原理",
                                "Session失效",
                                "URL重写",
                                "Session活化&钝化",
                                "Token令牌应用"
                            ]
                        },
                        {
                            "title": "Filter&Listener",
                            "skillList": [
                                "Filter原理",
                                "Filter声明周期",
                                "Filter链",
                                "Filter登录验证",
                                "Filter事务控制",
                                "Listener原理",
                                "八大监听器使用",
                                "Listener监听在线用户"
                            ]
                        },
                        {
                            "title": "MVC模式&三层架构",
                            "skillList": [
                                "MVC 模式概述",
                                "MVC 处理流程",
                                "三层架构概述",
                                "三层架构之控制层",
                                "三层架构之业务层",
                                "三层架构之数据访问层"
                            ]
                        }
                    ]
                },
                {
                    "phaseTitle": "第五阶段",
                    "phaseDesi": "单体架构项目：拉勾教育后台管理系统",
                    "class": "课时：23小时",
                    "phaseTargetList": [
                        "掌握自定义 MVC 框架和应用",
                        "熟悉前后分离架构设计和应用",
                        "掌握Java对json格式的转化应用",
                        "掌握Vue.js原理和应用",
                        "熟悉 Ajax 在项目中实战应用",
                        "掌握Maven环境搭建和使用",
                        "掌握Linux系统安装和操作、实现项目发布"
                    ],
                    "skillsList": [
                        "HTML5",
                        "CSS3",
                        "Ajax",
                        "Vue",
                        "MVC",
                        "JSON",
                        "Linux",
                        "Servlet",
                        "JavaBean",
                        "Maven",
                        "MySQL"
                    ],
                    "moduleList": [
                        {
                            "title": "Ajax&Json",
                            "skillList": [
                                "Ajax技术衍生",
                                "XMLHttpRequest使用",
                                "同步请求&异步请求",
                                "JSON语法",
                                "Java JSON转换",
                                "JavaScript JSON转换",
                                "jQuery 基本Ajax方法",
                                "底层$.ajax使用"
                            ]
                        },
                        {
                            "title": "Vue基础",
                            "skillList": [
                                "Vue简介",
                                "Vue快速入门",
                                "MVVM模式",
                                "Vue常用指令",
                                "Vue生命周期",
                                "Vue Ajax"
                            ]
                        },
                        {
                            "title": "Linux",
                            "skillList": [
                                "Linux系统-基础",
                                "Linux网络基础",
                                "Linux在VMware下的安装",
                                "Linux下Java环境的搭建",
                                "Linux下Tomcat安装和配置",
                                "Linux下 Oracle/MySQL 安装与配置",
                                "Shell 编程"
                            ]
                        },
                        {
                            "title": "拉勾教育后台管理系统",
                            "skillList": [
                                "项目介绍：手把手带你实现一个在线教育平台后台管理系统的核心功能",
                                "项目目的：通过系统的设计与实现，掌握JavaWeb开发、数据库访问技术、前端技术、前后端交互技术等核心技术点"
                            ]
                        }
                    ]
                },
                {
                    "phaseTitle": "第六阶段",
                    "phaseDesi": "企业级开发框架SSM",
                    "class": "课时：42小时",
                    "phaseTargetList": [
                        "熟悉 Spring 框架的模块结构和开发作用",
                        "掌握 SpringIOC、AOP核心模块原理和开发应用",
                        "掌握 SpringJDBC、SpringData等数据访问模块应用",
                        "掌握 SpringMVC模块原理和开发应用",
                        "掌握 MyBatis 框架原理和各种应用",
                        "掌握SSM框架整合开发和应用",
                        "熟悉 Maven、Git等开发环境应用"
                    ],
                    "skillsList": [
                        "Maven",
                        "MyBatis",
                        "SpringIOC",
                        "SpringAOP",
                        "SpringMVC",
                        "JdbcTemplate",
                        "SpringData",
                        "SpringSecurity",
                        "JPA",
                        "Git",
                        "SVN",
                        "Nginx",
                        "SSM项目"
                    ],
                    "moduleList": [
                        {
                            "title": "项目构建工具Maven",
                            "skillList": [
                                "Maven环境搭建",
                                "Maven构建&自动化构建",
                                "本地仓库&中央仓库",
                                "maven创建web工程",
                                "pom.xml、依赖管理",
                                "坐标、依赖、生命周期等",
                                "Idea下的maven使用",
                                "继承&amp;聚合",
                                "自动部署&持续集成&持续部署"
                            ]
                        },
                        {
                            "title": "MyBatis",
                            "skillList": [
                                "框架概述",
                                "MyBatis概述",
                                "自定义简易MyBatis",
                                "MyBatis快速入门",
                                "MyBatis的CRUD操作",
                                "MyBatis两种Dao实现模式",
                                "配置文件详解",
                                "注解开发"
                            ]
                        },
                        {
                            "title": "Spring",
                            "skillList": [
                                "Spring概述",
                                "Spring快速入门",
                                "Spring相关API",
                                "基于xml的Spring配置",
                                "基于注解的Spring配置",
                                "Spring面向切面编程（AOP）",
                                "Spring JDBCTemplate",
                                "声明式事务控制",
                                "Spring5新特性概述"
                            ]
                        },
                        {
                            "title": "SpringMVC",
                            "skillList": [
                                "SpringMVC概述",
                                "SpringMVC快速入门",
                                "请求数据绑定",
                                "响应数据",
                                "文件上传",
                                "异常处理机制",
                                "拦截器",
                                "SSM整合"
                            ]
                        },
                        {
                            "title": "项目协作工具Git",
                            "skillList": [
                                "Git安装配置",
                                "Git本地库搭建",
                                "Git常用操作命令",
                                "Github注册与配置",
                                "Github与Git协同办公",
                                "TortoiseGit安装配置",
                                "Egit操作push/pull",
                                "Git工作流",
                                "集中式&GitFlow&Forking"
                            ]
                        },
                        {
                            "title": "Nginx",
                            "skillList": [
                                "Nginx反向代理介绍",
                                "Nginx 下载和安装",
                                "Nginx 编译和启动、访问",
                                "搭建Nginx集群",
                                "解决Session共享问题"
                            ]
                        },
                        {
                            "title": "综合练习：用SSM框架改造拉勾教育后台管理系统",
                            "skillList": [
                                "项目介绍：手把手带你使用SSM框架进行在线教育平台后台管理系统的重构",
                                "项目目的：通过系统的设计与实现，掌握Spring、SpringMVC、MyBatis三大框架的整合，掌握Nginx、Git、Maven等核心工具的使用"
                            ]
                        }
                    ]
                },
                {
                    "phaseTitle": "第七阶段",
                    "phaseDesi": "分布式技术核心",
                    "class": "课时：24小时",
                    "phaseTargetList": [
                        "熟悉Dubbo框架原理和API应用",
                        "掌握Zookeeper原理和工作流程",
                        "熟悉Zookeeper为分布搭建、集群搭建",
                        "掌握Netty 异步IO通信框架原理和使用",
                        "熟悉FastDFS 概念、安装和配置",
                        "掌握Redis、MongoDB安装和命令操作",
                        "熟悉RabbitMQ概念、安装和配置"
                    ],
                    "skillsList": [
                        "分布式理论",
                        "Zookeeper",
                        "Dubbo",
                        "Redis",
                        "FastDFS",
                        "RabbitMQ"
                    ],
                    "moduleList": [
                        {
                            "title": "分布式架构理论",
                            "skillList": [
                                "分布式系统概论",
                                "分布式系统概念",
                                "分布式系统理论"
                            ]
                        },
                        {
                            "title": "Zookeeper",
                            "skillList": [
                                "Zookeeper 简介",
                                "Zookeeper 环境搭建",
                                "Zookeeper 基本使用",
                                "Zookeeper 应用场景",
                                "Zookeeper 注册中心"
                            ]
                        },
                        {
                            "title": "Dubbo",
                            "skillList": [
                                "分布式服务框架简介",
                                "Dubbo+zookeeper介绍",
                                "注册中心的安装启动",
                                "监控中心的启动",
                                "Dubbo在项目中整合",
                                "Dubbo的服务提供者配置和启动",
                                "Dubbo的服务消费者配置和启动",
                                "Dubbo运行测试",
                                "负载均衡和bug调试等其他功能"
                            ]
                        },
                        {
                            "title": "Redis",
                            "skillList": [
                                "NoSQL&Redis入门",
                                "Redis/memcache/MongoDB对比",
                                "Redis安装&amp;启动",
                                "分布式数据库CAP原理",
                                "Redis五大数据类型和基本操作命令",
                                "Redis总体配置Redis.conf",
                                "Redis持久化（RDB和AOF）",
                                "Redis事务控制",
                                "Redis发布和订阅",
                                "Redis（Master/Slave）主从复制",
                                "Jedis"
                            ]
                        },
                        {
                            "title": "FastDFS",
                            "skillList": [
                                "FastDFS简介",
                                "FastDFS安装和配置",
                                "FastDFS 配置Tracker服务器",
                                "FastDFS 配置Storage服务器",
                                "FastDFS 配置启动项",
                                "FastDFS 文件上传测试",
                                "FastDFS nginx的http访问代理配置",
                                "FastDFS java客户端测试",
                                "配置http访问"
                            ]
                        },
                        {
                            "title": "RabbitMQ",
                            "skillList": [
                                "RabbitMQ简介",
                                "RabbitMQ安装启动",
                                "RabbitMQ快速入门",
                                "RabbitMQ模式",
                                "RabbitMQ整合",
                                "消息成功确认机制",
                                "消费端限流",
                                "消息失效过期时间",
                                "死信队列",
                                "延迟队列",
                                "RabbitMQ集群"
                            ]
                        }
                    ]
                },
                {
                    "phaseTitle": "第八阶段",
                    "phaseDesi": "【分布式项目】拉勾教育学习平台",
                    "class": "课时：27小时",
                    "phaseTargetList": [
                        "掌握分布式架构设计及技术选型",
                        "掌握Dubbo+Zookeeper技术架构的应用",
                        "掌握基于Redis实现缓存、分布式锁等场景应用",
                        "掌握FastDFS服务器的搭建和访问",
                        "掌握单点登录、订单、支付、扫码等功能解决方案",
                        "掌握高并发、高可用、高性能系统的开发",
                        "掌握Linux环境的操作和项目发布"
                    ],
                    "skillsList": [
                        "Zookeeper",
                        "Dubbo",
                        "EasyCode",
                        "SSM",
                        "Redis",
                        "FastDFS",
                        "Linux",
                        "OAuth2",
                        "SSO",
                        "微信扫码",
                        "微信支付"
                    ],
                    "moduleList": []
                },
                {
                    "phaseTitle": "第九阶段",
                    "phaseDesi": "微服务技术核心",
                    "class": "课时：38小时",
                    "phaseTargetList": [
                        "熟悉 SpringBoot 框架的结构和自动配置等原理",
                        "熟悉Eureka、Ribbon、Hystrix、Feign、Gateway、Config等组件原理及应用",
                        "熟悉SpringCloudAlibaba核心组件原理及应用",
                        "熟悉ES概念、安装、配置，能进行集群环境搭建",
                        "掌握MySQL性能优化，以及MyCat和ShardingJDBC等分库分表中间件应用",
                        "熟悉 Kafka 概念、安装、配置",
                        "熟悉Docker概念、安装、配置和项目发布"
                    ],
                    "skillsList": [
                        "微服务概念",
                        "SpringBoot",
                        "SpringCloud",
                        "Spring Cloud Alibaba",
                        "Thymeleaf",
                        "Eureka",
                        "Ribbon",
                        "Hystrix",
                        "Feign",
                        "GateWay",
                        "Config",
                        "Nacos",
                        "Sentinel",
                        "Elasticsearch",
                        "Docker",
                        "Kafka",
                        "MyCat",
                        "ShardingJDBC",
                        "MySQL体系架构",
                        "InnoDB引擎原理",
                        "MySQL性能优化",
                        "MySQL索引分析",
                        "MySQL锁机制",
                        "MySQL高可用"
                    ],
                    "moduleList": [
                        {
                            "title": "SpringBoot",
                            "skillList": [
                                "SpringBoot原理",
                                "SpringBoot快速入门",
                                "yml配置文件以及多环境配置文件的使用",
                                "SpringBoot整合MyBatis",
                                "SpringBoot整合Redis进行数据缓存",
                                "SpringBoot中的RestTemplate发送Http请求",
                                "SpringBoot中的定时器",
                                "SpringBoot项目部署",
                                "SpringBoot的自动配置实现原理",
                                "Spring Boot Admin服务"
                            ]
                        },
                        {
                            "title": "SpringCloud",
                            "skillList": [
                                "微服务的概念",
                                "SpringCloud简介",
                                "SpringCloud常用组件和应用场景介绍",
                                "Eureka组件",
                                "Ribbon组件",
                                "Hystrix组件",
                                "Feign组件",
                                "Gateway组件",
                                "Config组件",
                                "SpringCloudAlibaba的组件"
                            ]
                        },
                        {
                            "title": "ElasticSearch",
                            "skillList": [
                                "ES简介",
                                "ES安装启动",
                                "ES快速入门",
                                "ES集成IK分词器",
                                "ES的相关概念",
                                "kibana操作索引库",
                                "ES集群环境搭建",
                                "Rest客户端操作索引库"
                            ]
                        },
                        {
                            "title": "Kafka",
                            "skillList": [
                                "Kafka 简介",
                                "Kafka 快速入门",
                                "Kafka 架构解读",
                                "Kafka 配置详解",
                                "Kafka 分区",
                                "Kafka 生产者/消费者实例"
                            ]
                        },
                        {
                            "title": "MyCat",
                            "skillList": [
                                "MyCat 简介",
                                "MyCat的下载和安装",
                                "MyCat分片配置",
                                "yCat分片使用和测试",
                                "MyCat读写分离",
                                "MyCat配置分库分表"
                            ]
                        },
                        {
                            "title": "ShardingJDBC",
                            "skillList": [
                                "ShardingJDBC 简介",
                                "分片策略与分片算法",
                                "ShardingJDBC配置"
                            ]
                        },
                        {
                            "title": "Docker",
                            "skillList": [
                                "Docker简介",
                                "Docker常用命令",
                                "Docker项目部署",
                                "Docker原理解析",
                                "Docker容器转为镜像",
                                "Docker自定义centos"
                            ]
                        }
                    ]
                },
                {
                    "phaseTitle": "第十阶段",
                    "phaseDesi": "【微服务项目】拉勾教育学习平台微服务改造",
                    "class": "课时：20小时",
                    "phaseTargetList": [
                        "掌握微服务架构设计及技术选型",
                        "掌握SpringBoot+SpringCloud技术架构的应用",
                        "掌握基于Redis实现缓存、分布式锁等场景应用",
                        "掌握ShardingJDBC中间件实现MySQL分库分表处理",
                        "掌握限流、分布式事务、配置中心的应用",
                        "掌握Docker容器化环境的构建和项目发布",
                        "掌握10+种互联网典型的技术解决"
                    ],
                    "skillsList": [
                        "SpringBoot",
                        "SpringCloud",
                        "Eureka",
                        "Ribbon",
                        "Hystrix",
                        "Feign",
                        "GateWay",
                        "Config",
                        "Redis",
                        "Docker",
                        "FastDFS",
                        "ShardingJDBC",
                        "Sentinel",
                        "Kafka",
                        "Seata",
                        "ElasticSearch",
                        "SSO",
                        "JWT"
                    ],
                    "moduleList": []
                },
                {
                    "phaseTitle": "第十一阶段",
                    "phaseDesi": "数据结构算法与调优",
                    "class": "课时：33小时",
                    "phaseTargetList": [
                        "熟悉字符串、数组、链表、栈、队列、树、图、堆等数据结构",
                        "熟悉排序、递归、回溯、查找等常见算法",
                        "熟悉MySQL高级技术、性能优化等",
                        "熟悉JVM底层结构、GC回收策略和算法、JVM性能调优",
                        "掌握并发编程及JUC常用API，以及原子变量与CAS 算法分析",
                        "掌握Lock、ReadWriteLock、CountDownLatch 、Condition等并发控制",
                        "熟悉线程池工作原理和机制，掌握ForkJoinPool 分支/合并框架"
                    ],
                    "skillsList": [
                        "JVM概念",
                        "JVM优化",
                        "JVM组成结构",
                        "GC回收策略",
                        "GC算法",
                        "并发编程",
                        "CAS",
                        "Lock",
                        "线程池",
                        "JUC",
                        "Volatile",
                        "Synchronized",
                        "Callable",
                        "ForkJoinPool"
                    ],
                    "moduleList": [
                        {
                            "title": "数据结构与算法",
                            "skillList": [
                                "字符串、数组、链表",
                                "栈、队列",
                                "树、图、堆",
                                "排序",
                                "递归",
                                "回溯",
                                "查找"
                            ]
                        },
                        {
                            "title": "MySQL高级",
                            "skillList": [
                                "MySQL架构组成",
                                "MySQL备份和恢复",
                                "MySQL查询和慢查询日志分析",
                                "MySQL索引优化",
                                "MySQL存储引擎优化",
                                "MySQL锁机制优化",
                                "MySQL高可用设计",
                                "MySQL集群"
                            ]
                        },
                        {
                            "title": "JVM优化",
                            "skillList": [
                                "JVM简析",
                                "JVM组成结构",
                                "JVM堆、栈原理",
                                "JVM-Heap三区原理",
                                "JVM垃圾收集机制",
                                "堆内存调优",
                                "GC回收策略",
                                "GC三大算法"
                            ]
                        },
                        {
                            "title": "Java并发高级",
                            "skillList": [
                                "volatile 关键字",
                                "内存可见性分析",
                                "原子变量与CAS (Compare And Swap) 算法分析",
                                "CountDownLatch 闭锁",
                                "实现 Callable 接口",
                                "Lock 同步锁",
                                "Condition 控制线程通信",
                                "线程按序交替",
                                "ReadWriteLock 读写锁",
                                "线程池",
                                "线程调度",
                                ".ForkJoinPool 分支/合并框架",
                                "工作窃取窃取模式",
                                "阻塞队列"
                            ]
                        }
                    ]
                },
                {
                    "phaseTitle": "第十二阶段",
                    "phaseDesi": "数据结构算法与调优",
                    "class": "课时：33小时",
                    "phaseTargetList": [
                        "掌握数据结构与算法高频面试题",
                        "掌握计算机网络、并发编程、JVM高频面试题",
                        "掌握JavaSE、数据库、JavaWeb、SSM、JVM高频面试题",
                        "掌握RPC框架、微服务高频面试题",
                        "掌握分布式存储、MQ中间件高频面试题",
                        "熟悉专项能力突击、打造一份优秀简历",
                        "熟悉如何在面试中发挥应有的实力"
                    ],
                    "skillsList": [
                        "面试题剖析",
                        "面试指导"
                    ],
                    "moduleList": [
                        {
                            "title": "技术面试题详解",
                            "skillList": [
                                "数据结构与算法篇",
                                "计算机网络篇",
                                "Linux系统篇",
                                "JavaSE篇",
                                "JavaWeb篇",
                                "SSM框架篇",
                                "JVM篇",
                                "并发编程篇",
                                "数据库篇",
                                "RPC框架篇",
                                "分布式存储篇",
                                "消息中间件篇",
                                "微服务篇"
                            ]
                        },
                        {
                            "title": "迎接面试：专项能力突击",
                            "skillList": [
                                "一面：编程基础能力考察",
                                "二面：项目经验考察",
                                "三面：方案设计综合能力考察",
                                "四面：HR综合软素质考察"
                            ]
                        },
                        {
                            "title": "如何打造一份让人无法拒绝的简历",
                            "skillList": [
                                "高分简历模板分析",
                                "打造一份高分简历的方法",
                                "模拟训练：重写简历1v1指导服务"
                            ]
                        },
                        {
                            "title": "如何在面试中发挥应有的实力",
                            "skillList": [
                                "学会表达：如何把硬实力表达出来",
                                "扬长避短：如何表现出自己的闪光点",
                                "洞悉套路：面试考察点与答题套路指导",
                                "模拟训练：大厂面试官1v1模拟面试",
                                "模拟面试复盘"
                            ]
                        }
                    ]
                }
            ],
            "rankList": [
                {
                    "companyLogo": "https://s21.lgstatic.com/growth/activity/20210412/1618215577506.jpeg",
                    "companyName": "太平洋保险",
                    "name": "苏同学",
                    "workYears": 1,
                    "education": "专科",
                    "term": "就业1期",
                    "salary": 378000,
                    "change": "70%"
                },
                {
                    "companyLogo": "https://s21.lgstatic.com/growth/activity/20210412/1618215585839.jpg",
                    "companyName": "字节跳动",
                    "name": "袁同学",
                    "workYears": 0,
                    "education": "本科",
                    "term": "就业2期",
                    "salary": 378000,
                    "change": "55%"
                },
                {
                    "companyLogo": "https://s21.lgstatic.com/growth/activity/20210412/1618215679522.png",
                    "companyName": "腾讯音乐",
                    "name": "李同学",
                    "workYears": 1,
                    "education": "本科",
                    "term": "就业1期",
                    "salary": 378000,
                    "change": "46%"
                },
                {
                    "companyLogo": "https://s21.lgstatic.com/growth/activity/20210412/1618215602413.jpg",
                    "companyName": "货拉拉",
                    "name": "孙同学",
                    "workYears": 0,
                    "education": "专科",
                    "term": "就业1期",
                    "salary": 378000,
                    "change": "43%"
                },
                {
                    "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606200370032.jpg",
                    "companyName": "网易",
                    "name": "李同学",
                    "workYears": 0,
                    "education": "硕士",
                    "term": "就业2期",
                    "salary": 378000,
                    "change": "37%"
                },
                {
                    "companyLogo": "https://s21.lgstatic.com/growth/activity/20210412/1618215613910.png",
                    "companyName": "汤臣倍健",
                    "name": "邓同学",
                    "workYears": 1,
                    "education": "专科",
                    "term": "就业1期",
                    "salary": 378000,
                    "change": "36%"
                },
                {
                    "companyLogo": "https://s21.lgstatic.com/growth/activity/20210412/1618215621231.jpg",
                    "companyName": "快手",
                    "name": "王同学",
                    "workYears": 0,
                    "education": "本科",
                    "term": "就业2期",
                    "salary": 378000,
                    "change": "32%"
                },
                {
                    "companyLogo": "https://s21.lgstatic.com/growth/activity/20210406/1617682710434.jpeg",
                    "companyName": "哈啰出行",
                    "name": "张同学",
                    "workYears": 1,
                    "education": "本科",
                    "term": "就业1期",
                    "salary": 378000,
                    "change": "59%"
                },
                {
                    "companyLogo": "https://s21.lgstatic.com/growth/activity/20210406/1617682702228.jpeg",
                    "companyName": "百度",
                    "name": "师同学",
                    "workYears": 1,
                    "education": "硕士",
                    "term": "就业1期",
                    "salary": 378000,
                    "change": "45%"
                },
                {
                    "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606199628854.jpg",
                    "companyName": "京东",
                    "name": "宋同学",
                    "workYears": 0,
                    "education": "硕士",
                    "term": "就业1期",
                    "salary": 378000,
                    "change": "32%"
                },
                {
                    "companyLogo": "https://s21.lgstatic.com/growth/activity/20201124/1606199982790.jpg",
                    "companyName": "好未来",
                    "name": "郭同学",
                    "workYears": 0.5,
                    "education": "本科",
                    "term": "就业1期",
                    "salary": 378000,
                    "change": "28%"
                },
                {
                    "companyLogo": "https://s21.lgstatic.com/growth/activity/20210406/1617682693828.jpg",
                    "companyName": "携程旅行",
                    "name": "林同学",
                    "workYears": 0.5,
                    "education": "本科",
                    "term": "就业1期",
                    "salary": 378000,
                    "change": "34%"
                }
            ]
        }
    }
}
